import PiezaUrlInfoField from '../PiezaUrlInfoField';
import { formatPrecio, sumPrecioVentaPiezas } from '../../utils';

const resolvePrecioVentaTotal = (piezas, precioVentaTotal) =>
    precioVentaTotal != null && precioVentaTotal !== ''
        ? precioVentaTotal
        : sumPrecioVentaPiezas(piezas);

const FILA_CLASS = 'd-flex align-items-start gap-3 py-2';
const PRECIO_COL_STYLE = { minWidth: '4.5rem' };

const PiezaOrigenItem = ({ pieza, hidePrecioVenta = false }) => (
    <div className="w-100 d-flex flex-column">
        <small className="d-flex flex-column">
            <span className="fw-bold text-success">{pieza.nombre ?? '-'}</span>
            {pieza.id_referencia_plataforma != null && (
                <span>
                    ID: <b>{pieza.id_referencia_plataforma}</b>
                </span>
            )}
            {pieza.referencia_pieza != null && (
                <span>
                    REF: <b>{pieza.referencia_pieza}</b>
                </span>
            )}
            {!hidePrecioVenta && (
                <span>
                    P. venta: <b>{formatPrecio(pieza.precio_venta)}</b>
                </span>
            )}
        </small>
    </div>
);

const PiezaDetalleItem = ({
    pieza,
    showGarantia = false,
    onCopyPiezaUrl,
    showUrl = false,
    hidePrecioVenta = false,
}) => (
    <div className="w-100 d-flex flex-column text-uppercase">
        <small className="d-flex flex-column">
            <span className="fw-bold text-success">{pieza.nombre ?? '-'}</span>
            <span>
                Proveedor: <b>{pieza.proveedor ?? '-'}</b>
            </span>
            {!hidePrecioVenta && (
                <span>
                    P. venta: <b>{formatPrecio(pieza.precio_venta)}</b>
                </span>
            )}
            {showGarantia && (
                <span>
                    Garantía: <b>{pieza.garantia ?? '-'}</b>
                </span>
            )}
            {showUrl && pieza.url && (
                <PiezaUrlInfoField
                    compact
                    piezaUrl={pieza.url}
                    onCopyPiezaUrl={onCopyPiezaUrl}
                />
            )}
        </small>
    </div>
);

const PiezaResponderItem = (props) => (
    <PiezaDetalleItem {...props} showGarantia />
);

const piezaItemComponents = {
    origen: PiezaOrigenItem,
    alternativa: PiezaDetalleItem,
    responder: PiezaResponderItem,
};

const PiezasConColumnaPrecio = ({
    piezas,
    variant,
    onCopyPiezaUrl,
    precioVentaTotal,
}) => {
    const ItemComponent = piezaItemComponents[variant] ?? PiezaOrigenItem;
    const showUrl = variant === 'alternativa';
    const hasTotal =
        precioVentaTotal != null && precioVentaTotal !== '';

    return (
        <div className="w-100 small">
            {piezas.map((pieza, index) => (
                <div
                    key={pieza.id ?? index}
                    className={`${FILA_CLASS}${
                        index < piezas.length - 1 || hasTotal
                            ? ' border-bottom'
                            : ''
                    }`}
                >
                    <div className="flex-grow-1 min-w-0">
                        <ItemComponent
                            pieza={pieza}
                            hidePrecioVenta
                            onCopyPiezaUrl={onCopyPiezaUrl}
                            showUrl={showUrl}
                        />
                    </div>
                    <div
                        className="fw-semibold text-nowrap flex-shrink-0 text-end"
                        style={PRECIO_COL_STYLE}
                    >
                        {formatPrecio(pieza.precio_venta)}
                    </div>
                </div>
            ))}
            {hasTotal && (
                <div className={FILA_CLASS}>
                    <span className="flex-grow-1 min-w-0 text-uppercase fw-semibold">
                        Total precio venta
                    </span>
                    <span
                        className="fw-semibold text-nowrap flex-shrink-0 text-end"
                        style={{ ...PRECIO_COL_STYLE, fontSize: '1rem' }}
                    >
                        {formatPrecio(precioVentaTotal)}
                    </span>
                </div>
            )}
        </div>
    );
};

const PiezasSinPrecio = ({ piezas, variant, onCopyPiezaUrl }) => {
    const ItemComponent = piezaItemComponents[variant] ?? PiezaOrigenItem;
    const showUrl = variant === 'alternativa';
    const lastIndex = piezas.length - 1;

    return (
        <div className="w-100 d-flex flex-column">
            {piezas.map((pieza, index) => (
                <div
                    key={pieza.id ?? index}
                    className={
                        index < lastIndex
                            ? 'mb-3 pb-3 border-bottom'
                            : undefined
                    }
                >
                    <ItemComponent
                        pieza={pieza}
                        hidePrecioVenta
                        onCopyPiezaUrl={onCopyPiezaUrl}
                        showUrl={showUrl}
                    />
                </div>
            ))}
        </div>
    );
};

const PiezasList = ({
    piezas = [],
    variant = 'origen',
    onCopyPiezaUrl,
    precioVentaTotal,
    showPrecioVenta = true,
}) => {
    if (!piezas?.length) {
        return <span>-</span>;
    }

    if (showPrecioVenta) {
        return (
            <PiezasConColumnaPrecio
                piezas={piezas}
                variant={variant}
                onCopyPiezaUrl={onCopyPiezaUrl}
                precioVentaTotal={resolvePrecioVentaTotal(
                    piezas,
                    precioVentaTotal,
                )}
            />
        );
    }

    return (
        <PiezasSinPrecio
            piezas={piezas}
            variant={variant}
            onCopyPiezaUrl={onCopyPiezaUrl}
        />
    );
};

export default PiezasList;
